/**
 * @sync-target レクシンユーザーメッセージ一覧 > 02_確認ダイアログ一覧
 */
export const DIALOG_MESSAGES = {
  PAGE_LEAVE: {
    UNSAVED_CHANGES: "編集内容が保存されていません。ページを離れてもよろしいですか？",
  },
  DELETE: {
    KINTONE_ADMIN: "kintone管理者情報を削除しますか？",
    KNOWLEDGE: (title: string) => `「${title}」を削除してもよろしいですか？` as const,
    CHAT_HISTORY: "会話履歴がすべて削除されます。よろしいですか？",
  },
  NAVIGATION: {
    EXTERNAL_PAGE: (feedbackUrl: string) =>
      `別のページに遷移します。よろしいですか？\n${feedbackUrl}` as const,
  },
  CREDIT_CONSUME: {
    APP_GENERATION_TITLE: "クレジットを使用してアプリを生成",
    APP_GENERATION_BODY: (creditCost: number) =>
      `アプリ生成回数が残っていません。${creditCost}クレジットを消費してアプリを生成しますか？` as const,
    APP_GENERATION_REMAINING_CREDIT: (remainingCredit: number) =>
      `残りクレジット: ${remainingCredit}` as const,
  },
} as const;
